module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VoteBase', {
    scopedSlots: _vm._u([{
      key: "voteMain",
      fn: function() {
        return [_c('b-form-group', {
          attrs: {
            "label": "APP ID",
            "label-for": "app_id"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "app_id",
            "type": "text"
          },
          model: {
            value: (_vm.app_id),
            callback: function($$v) {
              _vm.app_id = $$v
            },
            expression: "app_id"
          }
        })], 1), _vm._v(" "), _c('b-form-group', {
          attrs: {
            "label": "手机号",
            "label-for": "phone"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "phone",
            "type": "text"
          },
          model: {
            value: (_vm.phone),
            callback: function($$v) {
              _vm.phone = $$v
            },
            expression: "phone"
          }
        })], 1), _vm._v(" "), _c('b-form-group', {
          attrs: {
            "label": "验证码",
            "label-for": "authcode"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "authcode",
            "type": "text"
          },
          model: {
            value: (_vm.authcode),
            callback: function($$v) {
              _vm.authcode = $$v
            },
            expression: "authcode"
          }
        })], 1), _vm._v(" "), _c('b-form-group', {
          attrs: {
            "label": "投票ID",
            "label-for": "voteId"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "voteId",
            "type": "text"
          },
          model: {
            value: (_vm.voteId),
            callback: function($$v) {
              _vm.voteId = $$v
            },
            expression: "voteId"
          }
        })], 1), _vm._v(" "), _c('b-form-checkbox', {
          attrs: {
            "id": "checkbox-1",
            "name": "checkbox-1"
          },
          model: {
            value: (_vm.yidun),
            callback: function($$v) {
              _vm.yidun = $$v
            },
            expression: "yidun"
          }
        }, [_vm._v("\n      开启易盾\n    ")]), _vm._v(" "), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": _vm.getPhoneCode
          }
        }, [_vm._v("获取验证码")]), _vm._v(" "), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": _vm.phoneLogin
          }
        }, [_vm._v("登录")]), _vm._v(" "), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": _vm.vote
          }
        }, [_vm._v("点赞")]), _vm._v("\n    " + _vm._s(_vm.result) + "\n  ")]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c8f70a22!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vote/TestLoginAndVote.vue
// module id = 80Ps
// module chunks = 4